import {Box, css, FormControlLabel, styled} from '@mui/material';

const StyledCheckbox = styled(FormControlLabel)`
	margin: 0;
	font-size: 0.75rem;
	border-radius: 8px;
	gap: 9px;

	${({theme}) => theme.breakpoints.down('sm')} {
		align-items: start;
	}

	${({theme}) => css`
		background-color: ${theme.palette.background.paper};
		color: ${theme.colors.light.text.primary};
	`};
`;

const StyledBox = styled(Box)`
	cursor: pointer;
	text-decoration: underline;
	display: inline;
	line-height: normal;
	${({theme}) => css`
		color: ${theme.palette.primary.main};
	`};
`;

export {StyledCheckbox, StyledBox};
